// Import styles of packages that you've installed.
// All packages except `@mantine/hooks` require styles imports
import "@mantine/core/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/tiptap/styles.css";

import { DEFAULT_THEME, createTheme, mergeMantineTheme } from "@mantine/core";
import { PRIMARY_COLORS } from "./colors";

const themeOverride = createTheme({
	fontFamily: "Noto Sans JP, sans-serif",
	fontFamilyMonospace: "Noto Sans JP, sans-serif",
	headings: {
		fontFamily: "Noto Sans JP, sans-serif",
	},
	colors: {
		primary: PRIMARY_COLORS,
	},
	primaryColor: "primary",
	components: {
		Badge: {
			styles: {
				root: {
					textTransform: "none",
				},
			},
		},
	},
});

// NOTE: DEFAULT_THEME（https://mantine.dev/theming/default-theme/）
export const theme = mergeMantineTheme(DEFAULT_THEME, themeOverride);
